import { getNotAppliedCreditMemo, GetNotAppliedCreditMemoParams, GetNotAppliedCreditMemoResponse } from '@ar/network/AccountsReceivable.network';
import { useQueries, useQuery, UseQueryResult } from '@tanstack/react-query';

export const FETCH_NOT_APPLIED_CREDIT_MEMO_QUERY_KEY = 'FETCH_NOT_APPLIED_CREDIT_MEMO_QUERY_KEY';

export const useGetNotAppliedCreditMemo = (params: GetNotAppliedCreditMemoParams): UseQueryResult<GetNotAppliedCreditMemoResponse> => useQuery(
    [FETCH_NOT_APPLIED_CREDIT_MEMO_QUERY_KEY, params],
    async () => getNotAppliedCreditMemo(params),
    { enabled: Boolean(params.supplierId) && Boolean(params.customerId) },
);

export type CustomerCreditData = {
    supplierId: string,
    customerId: string,
    availableCredits: number,
    data: GetNotAppliedCreditMemoResponse,
};

/**
 * Hook to fetch credit memos for multiple customers in parallel
 */
export const useGetNotAppliedCreditMemos = (
    supplierId: string,
    customerIds: string[],
): UseQueryResult<CustomerCreditData>[] => useQueries({
    queries: customerIds.map((customerId) => ({
        queryKey: [FETCH_NOT_APPLIED_CREDIT_MEMO_QUERY_KEY, supplierId, customerId],
        queryFn: async (): Promise<CustomerCreditData> => {
            const data = await getNotAppliedCreditMemo({ supplierId, customerId });
            const availableCredits = data?.reduce((sum, memo) => sum + memo.credit, 0) ?? 0;
            return {
                supplierId,
                customerId,
                availableCredits,
                data,
            };
        },
        enabled: Boolean(supplierId) && Boolean(customerId),
    })),
});
